import React from 'react';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider as Provider } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.errorMessage) {
        enqueueSnackbar(query.meta.errorMessage, { variant: 'error' });
      }
    }
  }),
  mutationCache: new MutationCache({
    onError: (error: any, variables: any, context, mutation: any) => {
      if (error.response?.status === 403) {
        enqueueSnackbar('User not authorized to perform requested action', { variant: 'error' });
        return;
      }

      const apiErrorMessage = error.response?.data?.error?.text;
      if (apiErrorMessage) {
        enqueueSnackbar(apiErrorMessage, { variant: 'error' });
        return;
      }

      if (mutation.meta?.errorMessage) {
        if (typeof mutation.meta.errorMessage === 'string') {
          enqueueSnackbar(mutation.meta.errorMessage, { variant: 'error' });
          return;
        }

        const errorMessage = variables[mutation.meta.errorMessage.field]
          ? mutation.meta.errorMessage.update
          : mutation.meta.errorMessage.create;
        if (errorMessage) {
          enqueueSnackbar(errorMessage, { variant: 'error' });
          return;
        }
      }

      enqueueSnackbar(error.message, { variant: 'error' });
    }
  })
});

interface Props {
  children: React.ReactNode;
}

const QueryClientProvider = ({ children }: Props) => {
  return <Provider client={queryClient}>{children}</Provider>;
};
export default QueryClientProvider;
